/**
 * 登録パターン
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/entry_patterns`;

const master_entry_pattern = {
  namespaced: true,
  state: () => {},
  getters: {},
  actions: {
    /**
     * 登録パターン取得
     * @param commit
     * @param conditions { Object } 検索条件
     * @param conditions.order_type { String } オーダー種別
     * @param conditions.emission_id { Number } 排出事業者ID
     * @param conditions.emission_location_id { Number, null } 排出事業場ID
     * @param conditions.keyword { String, null } キーワード
     * @param conditions.is_primary { Boolean, null } デフォルト設定のみ
     * @return {Promise<unknown>}
     */
    index({ commit }, { conditions }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: conditions }).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 登録パターン編集情報取得
     * @param commit
     * @param id { Number } 登録パターンID
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}`).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 登録パターン新規登録
     * @param commit
     * @param params { Object } 登録パターン
     * @return {Promise<unknown>}
     */
    create({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, params).then((data) => {
          let content = data.content;
          commit(
            "snackbar/showInfo",
            { message: "登録しました" },
            { root: true }
          );
          resolve(content);
        });
      });
    },

  },
  mutations: {},
};

export default master_entry_pattern;
